import React, { useState } from "react";

import { EdgeConfigList } from "./List";
import { V3BatchEdit } from "./V3BatchEdit";

const EdgeConfigV3List = (props) => {
    const [bulkEditing, setBulkEditing] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);

    if (bulkEditing) {
        return (
            <V3BatchEdit
                {...props}
                selectedIds={selectedIds}
                onCancel={() => setBulkEditing(false)}
                onSuccess={() => setBulkEditing(false)}
            />
        );
    }

    return (
        <EdgeConfigList
            onBulkEdit={(selectedIds) => {
                setSelectedIds(selectedIds);
                setBulkEditing(true);
            }}
            {...props}
        />
    );
};

export { EdgeConfigV3List };
